import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React, { useContext, useEffect, useState } from 'react'
import OurPeople from '../../components/whoWeAre/OurPeople';
import OurStory from '../../components/whoWeAre/OurStory'
import OurPromises from '../../components/whoWeAre/OurPromises';
import OurVideo from '../../components/whoWeAre/OurVideo';
import OurPartners from '../../components/whoWeAre/OurPartners';
import CommonBanner from '../../components/common/CommonBanner';
import { NextSeo } from 'next-seo';
import { useTranslation } from 'next-i18next';
import { dehydrate, QueryClient, useQuery } from "react-query"
import { useRouter } from 'next/router';
import { fetchData, BASE_URL } from '../../utils/FetchData';
import { scroller } from 'react-scroll';
import LoadingPage from '../../components/LoadingPage'
import Footer from '@/components/common/Footer';
import { nextRouteContext } from '@/contexts/nextRouteContext';
export default function Index() {
    const { t } = useTranslation('common');
    const { locale, query } = useRouter()
    const [whoWeData, setWhoWeData] = useState();
    const { data, isSuccess, isLoading, isError } = useQuery(["whoWeData", locale], () =>
        fetchData(
            "who-we-are",
            locale,
            "populate[0]=Banner.img_desktop&populate[1]=Banner.img_mobile&populate[2]=our_story.img_desktop&populate[3]=our_story.img_mobile&populate[4]=our_promise.promise.icon&populate[5]=our_company.img_desktop&populate[6]=our_company.img_mobile&populate[7]=our_people.peoples.img_desktop&populate[8]=our_people.peoples.img_mobile&populate[9]=our_partners.Consultants.img_desktop&populate[10]=our_partners.Consultants.img_mobile&populate[11]=our_partners.Contractors.img_desktop&populate[12]=our_partners.Contractors.img_mobile&populate[13]=our_partners.Designers.img_desktop&populate[14]=our_partners.Designers.img_mobile&populate[15]=SEO.Img"
        )
    )
    const [pageLoading, setPageLoading] = useState(true)
    useEffect(() => {
        let timeOut = ''
        setPageLoading(true)
        if (!isLoading) {
            timeOut = setTimeout(() => {
                setPageLoading(false)
            }, 2500)
        }
        return () => clearTimeout(timeOut)
    }, [isLoading])

    useEffect(() => {
        isSuccess && setWhoWeData(data?.data.attributes)
    }, [data, isSuccess])

    useEffect(() => {
        if (query.section) {
            scroller.scrollTo(query.section, {
                duration: 500,
                delay: 2000,
                smooth: "easeInOutQuad",
            });
        }
    }, [query.section]);

    // if (pageLoading) {
    //     return <LoadingPage />;
    // }
    if (data?.error?.status == 404 || isError) {
        return <LoadingPage error />;
    }
    return (
        <>
            <NextSeo
                title={data?.data?.attributes?.SEO?.Title}
                description={data?.data?.attributes?.SEO?.Description}
                openGraph={{
                    type: 'website',
                    url: 'https://www.hydeparkdevelopments.com/who-we-are',
                    title: data?.data?.attributes?.SEO?.Title,
                    images: [
                        { url: BASE_URL + data?.data?.attributes?.SEO?.Img?.data?.attributes?.url },
                    ],
                    siteName: 'Hyde Park Developments',
                }}
            />
            <LoadingPage pageLoading={pageLoading} />
            <CommonBanner
                bannerData={whoWeData?.Banner}
                pageLoading={pageLoading}
            />
            <OurStory ourStoryData={whoWeData?.our_story} />
            {whoWeData?.our_promise && <OurPromises
                dataList={whoWeData?.our_promise?.promise}
                header={whoWeData?.our_promise?.header}
            />}
            {/* {whoWeData?.our_company && <OurVideo ourCompany={whoWeData?.our_company} />} */}
            {whoWeData?.our_people && <OurPeople ourPeople={whoWeData?.our_people} />}
            {whoWeData?.our_partners?.header && <OurPartners ourPartners={whoWeData?.our_partners} />}
            {whoWeData && <Footer />}
        </>
    )
}
export async function getServerSideProps({ locale }) {
    const queryClient = new QueryClient()
    await queryClient.prefetchQuery(["whoWeData", locale], () =>
        fetchData(
            "who-we-are",
            locale,
            "populate[0]=Banner.img_desktop&populate[1]=Banner.img_mobile&populate[2]=our_story.img_desktop&populate[3]=our_story.img_mobile&populate[4]=our_promise.promise.icon&populate[5]=our_company.img_desktop&populate[6]=our_company.img_mobile&populate[7]=our_people.peoples.img_desktop&populate[8]=our_people.peoples.img_mobile&populate[9]=our_partners.Consultants.img_desktop&populate[10]=our_partners.Consultants.img_mobile&populate[11]=our_partners.Contractors.img_desktop&populate[12]=our_partners.Contractors.img_mobile&populate[13]=our_partners.Designers.img_desktop&populate[14]=our_partners.Designers.img_mobile&populate[15]=SEO.Img"
        )
    )
    return {
        props: {
            dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
            ...(await serverSideTranslations(locale, ["common"])),
        },
    };
}
